(function(global) {
  // Verificar y definir las variables globales solo si no están definidas
  if (typeof global.btn_class === 'undefined') {
    global.btn_class = document.querySelectorAll('.btn_quick_add_movil') || [];
  } else {
    // Si ya está definida y necesitas actualizarla
    global.btn_class = document.querySelectorAll('.btn_quick_add_movil') || [];
  }

  if (typeof global.idItemProduct === 'undefined') {
    global.idItemProduct = "";
  } else {
    // Si ya está definida y necesitas actualizarla
    global.idItemProduct = "";
  }

  if (typeof global.idProduct === 'undefined') {
    global.idProduct = "";
  } else {
    // Si ya está definida y necesitas actualizarla
    global.idProduct = "";
  }

  if (typeof global.idContSelector === 'undefined') {
    global.idContSelector = "";
  } else {
    // Si ya está definida y necesitas actualizarla
    global.idContSelector = "";
  }

  if (typeof global.idBtnCompra === 'undefined') {
    global.idBtnCompra = "";
  } else {
    // Si ya está definida y necesitas actualizarla
    global.idBtnCompra = "";
  }

  if (typeof global.idBtnCerrar === 'undefined') {
    global.idBtnCerrar = "";
  } else {
    // Si ya está definida y necesitas actualizarla
    global.idBtnCerrar = "";
  }

})(window);



btn_class.forEach(item => {
  item.addEventListener('click', function(e) {
    idItemProduct = this.id;
    idProduct = idItemProduct.split("_");
    idContSelector = "contQuickAdd_"+idProduct[1];
    idBtnCompra = "add-to-cart-"+idProduct[1];
    idBtnCerrar = "btnCerrado-"+idProduct[1];

    let quickAddModalNew = document.querySelector('body > quick-add-modal-new');
    if(quickAddModalNew){
      document.body?.removeChild(quickAddModalNew);
    }
    
    quickAddModalNew = item.nextElementSibling;
    
    let quickAddModalNewCloned = quickAddModalNew.cloneNode(true); 
    quickAddModalNewCloned.style.position = 'fixed';
    quickAddModalNewCloned.style.bottom = '0';

    document.body.prepend(quickAddModalNewCloned);
    document.body.style.overflow = 'hidden';

    setInnerHTML(quickAddModalNewCloned, quickAddModalNewCloned.innerHTML );
    
    Array.from(document.querySelectorAll(".cont_info_quick_add_desck")).forEach(el => el.style.display = 'none');

    document.getElementById(`${idContSelector}`).style.display = 'block';
    
    document.getElementById(idContSelector).getBoundingClientRect(); 

    //CERRADO DEL POP EN MOVIL
    let cerrar = document.getElementById(idBtnCerrar);
    let cerraragregado = document.getElementById(idBtnCompra);
    
    cerrar.addEventListener('click', function(){
      $("#"+idContSelector).css("display","none");  
      document.body.style.overflow = 'scroll';
    });
    
    cerraragregado.addEventListener('click', function(){
      document.body.style.overflow = 'scroll';
      $("#"+idContSelector).css("display","none");  
    });    
  });
});

if (!customElements.get('quick-add-modal-new')) {
  customElements.define(
    'quick-add-modal-new',
    class QuickAddModal extends HTMLElement{
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="contQuickAdd_"]');
      }
    });
}

function setInnerHTML(element, html) {
  // element.innerHTML = html;

  // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
  element.querySelectorAll('script').forEach((oldScriptTag) => {
    const newScriptTag = document.createElement('script');
    Array.from(oldScriptTag.attributes).forEach((attribute) => {
      newScriptTag.setAttribute(attribute.name, attribute.value);
    });

    newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
    oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
  });
}
